// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__w9LLa","logo":"NavBar_logo__zU4Hu","hamburger":"NavBar_hamburger__+Hgqk","display":"NavBar_display__I+nfb"};